import { FASTElement, css, customElement, observable } from '@microsoft/fast-element';

import { expandCardTemplate, simpleCardTemplate } from './template.js';
import { expandCardHoverStyles, expandCardStyles, simpleCardStyles } from './styles.js';
import { typeRampStyles } from '../../type-ramp.js';

export class Card extends FASTElement {}

const touchStyles = css`
	.body {
		${expandCardHoverStyles}
	}
`;

@customElement({
	name: 'expand-card',
	template: expandCardTemplate,
	styles: [typeRampStyles, expandCardStyles]
})
export class ExpandCard extends Card {
	@observable
	public body!: HTMLElement;

	private touched: boolean = false;

	public handleTouchstart(event: TouchEvent): boolean {
		if (!(event.composedPath().includes(this.body))) {
			this.$fastController.removeStyles(touchStyles);
		} else {
			this.touched = !!this.touched;
			
			if (this.touched) {
				this.$fastController.removeStyles(touchStyles);
			} else {
				this.$fastController.addStyles(touchStyles);
			}
		}

		return true;
	}

	connectedCallback(): void {
		super.connectedCallback();

		document.addEventListener('touchstart', this.handleTouchstart.bind(this), { passive: true });
		this.body.addEventListener('touchstart', this.handleTouchstart.bind(this), { passive: true });
	}

	disconnectedCallback(): void {
		document.removeEventListener('touchstart', this.handleTouchstart.bind(this));
		this.body.removeEventListener('touchstart', this.handleTouchstart.bind(this));
		
		super.disconnectedCallback();
	}
}

@customElement({
	name: 'simple-card',
	template: simpleCardTemplate,
	styles: [typeRampStyles, simpleCardStyles]
})
export class SimpleCard extends Card {}